import { render, staticRenderFns } from "./ManualRegistration.vue?vue&type=template&id=82438e64&scoped=true&"
import script from "./ManualRegistration.vue?vue&type=script&lang=js&"
export * from "./ManualRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ManualRegistration.vue?vue&type=style&index=0&id=82438e64&prod&lang=css&"
import style1 from "./ManualRegistration.vue?vue&type=style&index=1&id=82438e64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82438e64",
  null
  
)

export default component.exports